import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "components/app/dialog/dialog";
import { Button } from "components/ui/button";
import { X, Loader } from "lucide-react";
import { useState } from "react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import { AppLog } from "services";
import { ScrollArea } from "components/ui/scroll-area";
import { logoFlipFlop } from "assets";

interface DialogProps {
  onUploadSuccess: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  soundData: any;
}

export default function DialogSendSharedMusic({ isDialogOpen, setIsDialogOpen, onUploadSuccess, soundData }: DialogProps) {
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoadingSubmit(true);
    try {
      let url: string = "";
      url = RouteApi.submitRemoveShareMusic;
      url += `token=${Service.token}`;
      const data = {
        sound_id: soundData?.sound_id,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            onUploadSuccess(responses.music);
            setIsDialogOpen(false);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[handleSubmit]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="h-[calc(100vh-80px)] w-full md:max-w-[600px] lg:max-w-[1000px] flex flex-col justify-between p-0">
        <DialogHeader className="mt-4 border-b-2 pb-4">
          <DialogTitle className="text-center">Shared Music</DialogTitle>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="h-full px-4">
          <div className="flex items-center">
            <img src={soundData.thumbnail ?? logoFlipFlop} className="w-[40px] h-[40px] rounded-full" alt="thumbnail" />
            <audio controls src={soundData.sound_url} className="py-1 ms-4" />
          </div>
          <br />

          <p className="ms-4">The music is already shared to another user on the platform!</p>
          <br />

          <ul className="list-disc pl-5 space-y-2">
            <li>
              <span className="font-semibold">Title:</span> {soundData.sound_title}
            </li>
            <li>
              <span className="font-semibold">Artist Name:</span> {soundData.singer}
            </li>
            <li>
              <span className="font-semibold">Author:</span> {soundData.sound_author}
            </li>
            <li>
              <span className="font-semibold">Genre:</span> {soundData.sound_genres}
            </li>
            <li>
              <span className="font-semibold">Album:</span> {soundData.sound_album}
            </li>{" "}
            <li>
              <span className="font-semibold">Price:</span> {soundData.commercial_price}
            </li>
          </ul>
        </ScrollArea>
        <DialogFooter className="flex justify-between gap-3">
          <Button disabled={loadingSubmit} onClick={handleSubmit} className="bg-red-600 text-white w-full hover:bg-red-500 mt-3">
            {loadingSubmit ? <Loader className="animate-spin" /> : "Stop Share"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
